"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCommit = void 0;
const micro_starknet_1 = require("micro-starknet");
/**
 * Computes the Poseidon hash of a execution payload for StarkNet
 * This can be used to produce the input for calling the commit method in the StarkNet Commit contract.
 * @param target The target address of the execution
 * @param selector The selector for the method at address target one wants to execute
 * @param calldata The payload for the method at address target one wants to execute
 */
const getCommit = (target, selector, calldata) => {
    return `0x${(0, micro_starknet_1.poseidonHashMany)([target, selector, ...calldata].map(v => BigInt(v))).toString(16)}`;
};
exports.getCommit = getCommit;
